import { useParams } from "react-router-dom";
import { useUserProfile } from "../../../shared/hooks/useUserProfile";
import AuthenticatedLayout from "../../../shared/layouts/AuthenticatedLayout";
import ProfileCard from "../components/ProfileCard";

export default function UserProfile() {
  const { userId } = useParams<{ userId: string }>();
  const { profile, isLoading, error, refetch } = useUserProfile(userId, {
    include: ["tests"],
    staleTime: 0,
    refetchOnWindowFocus: true,
  });

  return (
    <AuthenticatedLayout isLoading={isLoading} error={error}>
      <ProfileCard profile={profile} onRefresh={refetch} />
    </AuthenticatedLayout>
  );
}
